interface NavigatorWithServiceWorker {
  serviceWorker?: {
    getRegistrations?: () => Promise<readonly ServiceWorkerRegistration[]>;
    register: (scriptURL: string, options?: RegistrationOptions) => Promise<ServiceWorkerRegistration>;
  };
}

export async function registerInventoryServiceWorker(
  input: { enabled?: boolean; navigatorLike?: NavigatorWithServiceWorker; scriptUrl?: string } = {},
) {
  const navigatorLike = input.navigatorLike ?? globalThis.navigator;
  const serviceWorker = navigatorLike.serviceWorker;
  const isEnabled = input.enabled ?? import.meta.env.PROD;

  if (!serviceWorker) {
    return;
  }

  if (!isEnabled) {
    await unregisterInventoryServiceWorkers(serviceWorker);
    await deleteInventoryServiceWorkerCaches();

    return;
  }

  try {
    await serviceWorker.register(input.scriptUrl ?? '/service-worker.js');
  } catch {
    // Registration is best-effort; the app still works online without the offline shell.
  }
}

async function unregisterInventoryServiceWorkers(
  serviceWorker: NonNullable<NavigatorWithServiceWorker['serviceWorker']>,
) {
  try {
    const registrations = await serviceWorker.getRegistrations?.();
    await Promise.all(registrations?.map(registration => registration.unregister()) ?? []);
  } catch {
    // Best-effort cleanup for development. Registration diagnostics stay non-fatal.
  }
}

async function deleteInventoryServiceWorkerCaches() {
  try {
    const cacheStorage = globalThis.caches;
    const cacheKeys = await cacheStorage?.keys();
    await Promise.all(cacheKeys?.map(cacheKey => cacheStorage.delete(cacheKey)) ?? []);
  } catch {
    // Best-effort cleanup for development. Cache APIs can be unavailable in tests or private browsing.
  }
}
